import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import s from './H2.module.scss'

function H2({ className, children, bold, muted, inline, ...props }) {
  const classes = classnames(s.h2, className, {
    [s.bold]: bold,
    [s.muted]: muted,
    [s.inline]: inline
  })

  return (
    <div className={classes} role="heading" aria-level="2" {...props}>
      {children}
    </div>
  )
}

H2.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  bold: PropTypes.bool,
  muted: PropTypes.bool,
  inline: PropTypes.bool
}

H2.defaultProps = {
  className: null,
  children: null,
  bold: false,
  muted: false,
  inline: false
}

export default H2
